
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-new-password",
      function () {
        return require("private-next-pages/create-new-password/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-new-password"])
      });
    }
  